import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { ProductGrid } from "../product";

export function FeaturedSection({ products }) {
  const navigate = useNavigate();
  const featured = products.filter(p => p.collection === "Featured");
  
  return (
    <section className="py-20 px-4 bg-black" data-testid="featured-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-12">
          <div>
            <span className="text-red-500 text-sm tracking-widest uppercase">Featured</span>
            <h2 className="text-white text-4xl sm:text-5xl font-bebas mt-2">Hot Right Now</h2>
          </div>
          <button onClick={() => navigate('/shop')} className="flex items-center gap-2 text-white/60 hover:text-amber-400" data-testid="view-all-btn">View All <ChevronRight size={20} /></button>
        </div>
        <ProductGrid products={featured} />
      </div>
    </section>
  );
}
